import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

document.querySelectorAll('.timeline-slider').forEach((el) => {
  const container = el.querySelector('.swiper')
  const numSlides = el.querySelectorAll('.swiper-slide').length

  if (numSlides > 1) {
    new Swiper(container, {
      modules: [A11y, Navigation],
      loop: true,
      speed: 500,
      navigation: {
        nextEl: el.querySelector('.slider-button-next'),
        prevEl: el.querySelector('.slider-button-prev'),
      },
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 36,
        },
        1536: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    })
  }
})
